import { TPaginatedTotals } from "@types";
import { BaseModel } from "./_base.model";

export class Collection<T extends BaseModel> {
	public data: T[] = [];
	totals: {
		page: number,
		pageSize: number,
		totalPages: number,
		thisPageCount: number,
		totalCount: number,
		hasNextPage: boolean,
		hasPreviousPage: boolean
	};

	constructor(modelList: T[], totalsData?: TPaginatedTotals) {
		this.data = modelList;
		this.totals = totalsData || {
			page: 1,
			pageSize: modelList.length,
			totalPages: 1,
			thisPageCount: modelList.length,
			totalCount: modelList.length,
			hasNextPage: false,
			hasPreviousPage: false
		};
	}

	first(): T | null {
		return this.data.length ? this.data[0] : null;
	}

	last(): T | null {
		return this.data.length ? this.data[this.data.length-1] : null;
	}

	size(): number {
		return this.data.length;
	}

}